import type { FC, PropsWithChildren } from 'react';

type PageWrapperProps = PropsWithChildren;

const PageWrapper: FC<PageWrapperProps> = ({ children }) => {
	return (
		<div
			className="mx-auto h-full w-full max-w-4xl"
			data-testid="page-wrapper"
		>
			<div data-testid="page-wrapper-body">{children}</div>
		</div>
	);
};

export default PageWrapper;
